import { Box, Grid } from '@mui/material';
import React from 'react';
import { dashBoardConfig, defaultConfig } from '../../Themes/themeConfigLogin';

interface MultipleChoiceQuestionProps {
  question: any;
  options: any;
  isMobilescreen: any;
  handleSingleSelect: any;
  selectedOption: any;
  imPayload: any;
  clickable: boolean;
}

const MultipleChoiceQuestion: React.FC<MultipleChoiceQuestionProps> = ({ question, options, isMobilescreen, handleSingleSelect, selectedOption, imPayload, clickable }) => {
  /**
   * @param item the option if it is present
   * @returns boolean the option if it is present, returns true
   */
  const isSelected = (item: any) => {
    if (selectedOption && selectedOption.length > 0) {
      return selectedOption === item;
    }
    return false;
  };

  return (
    <Box component={'div'} padding={'16px 17px 17px 18px'} border={dashBoardConfig.borderStyleDefault} className="card h-100" width={'100%'}>
      <h1 className={`${defaultConfig.primaryFont} mb-3`}>{question}</h1>
      <Box component={'div'}>
        <Box component={'div'} className={isMobilescreen ? 'd-flex w-100 mt-4' : 'd-flex justify-content-evenly w-100'} overflow={'auto'}>
          <Box component={'div'} className={isMobilescreen ? 'd-flex  w-100 mt-4' : 'd-flex justify-flex-start w-100 mt-4'}>
            {options &&
              options.map((item: any, index: number) => (
                <Box
                  component={'button'}
                  className={isSelected(item) ? defaultConfig.whiteFonts : defaultConfig.blackFonts}
                  marginRight={'50px'}
                  padding={'15px 20px'}
                  border={dashBoardConfig.borderStyle2Default}
                  borderRadius={'4px'}
                  bgcolor={isSelected(item) ? defaultConfig.primaryColor : defaultConfig.tertiaryColor}
                  onClick={() => {
                    !clickable && handleSingleSelect(item, question, options, 0);
                  }}
                >
                  {item}
                </Box>
              ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default MultipleChoiceQuestion;
